<template>
  <b-modal
    v-model="show"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    @hide="hideModal"
  >
    <form
      v-if="user"
      id="blockWarning"
      @submit.prevent="blockUser"
    >
      <div class="modal-header align-items-center">
        <h2
          id="ModalLabel"
          class="modal-title"
        >
          Блокировка пользователя
        </h2>
        <i class="material-icons">lock</i>
      </div>
      <div class="modal-body">
        Блокировка пользователя уберёт все права у пользователя, продолжить?
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-secondary-ford-gray modal-ext"
          type="button"
          @click="hideModal"
        >
          Отмена
        </button>
        <button
          class="btn btn-primary-ford-orange modal-ext"
          type="submit"
        >
          Заблокировать
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: 'AddUser',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    show: false,
    isLoading: false,
  }),
  watch: {
    value(val) {
      this.$store.commit('setBackgroundBlur', val);
      this.show = val;
    },
  },
  methods: {
    hideModal() {
      this.$emit('input', false);
    },
    blockUser() {
      this.$emit('blockUser', this.user.id);
    },
  },
};
</script>
